<template>
  <div class="w-full">
    <!-- Section header (exclude if no metrics are in search results) -->
    <div v-if="showInSearch" class="flex items-center gap-1 mb-2.5">
      <PartnershipAdsIcon class="text-icon-muted" />
      <BaseText id="uniquemetrics" ref="uniquemetrics" type="heading" size="sm" class="text-text-muted metric-section">
        Unique Metrics
      </BaseText>
    </div>
    <div class="w-full flex flex-col">
      <div v-for="uniqueMetric in searchList" :id="`unique-metric-${uniqueMetric.key}`" :key="`unique-metric-${uniqueMetric.key}`"
      class="w-full flex items-center gap-3 relative p-1.5 hover:bg-background-normal cursor-pointer rounded-lg"
      @mouseenter="hoveredMetric = uniqueMetric" @mouseleave="hoveredMetric = null">
        <div class="h-4 w-4 checkbox-input rounded bg-neutral-50 opacity-50" />
        <BaseText type="label" size="sm" class="text-neutral-600">
          {{ uniqueMetric.name }}
        </BaseText>
      </div>
    </div>
    <!-- Info Footer -->
    <div v-if="showInSearch" class="w-full flex items-start gap-2 pt-2.5 pl-2.5 pr-6 pb-1.5 rounded-xl bg-neutral-25 mt-5">
      <InfoRectIcon class="text-icon-normal flex-shrink-0" />
      <BaseText type="body" size="sm" class="text-text-normal relative bottom-0.5" style="line-height: 24px">
        Unique metrics count people, not impressions. This data cannot be summed accross ad groups or added to columns/filters.
        Open any Ad Details <span class="inline-icon"><AdDetailsAnimatedIcon /></span> to see them, queried live from {{ platformName }}.
      </BaseText>
    </div>
    <div v-if="showDivider" class="w-full border-t border-border-normal my-8" />
    <!-- Tooltip -->
    <MetricHoverTooltip :hovered-metric="hoveredMetric" id-prefix="unique-metric-" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { uniqueMetricsLookup, getUniqueMetricDisplayKeys } from '@/utils/lens/uniqueMetricsUtils'
import { platformNameMap } from '@/utils/lens/dataSourceUtils'

// Components
import MetricHoverTooltip from '../MetricHoverTooltip.vue'

// Icons
import InfoRectIcon from '../../../globals/Icons/InfoRectIcon.vue'
import AdDetailsAnimatedIcon from '../../../globals/Icons/AdDetailsAnimatedIcon.vue'
import PartnershipAdsIcon from '../../../globals/Icons/SpyderModeIcons/PartnershipAdsIcon.vue'

export default {
  name: 'UniqueMetricsInfo',
  components: {
    MetricHoverTooltip,
    InfoRectIcon,
    AdDetailsAnimatedIcon,
    PartnershipAdsIcon
  },
  data () {
    return {
      hoveredMetric: null
    }
  },
  computed: {
    ...mapGetters('MetricsModule', ['getMetricsPlatform', 'getMetricSearch', 'getFuzzyResults']),
    uniqueMetricsList () {
      const displayKeys = getUniqueMetricDisplayKeys(this.getMetricsPlatform)
      return displayKeys.map(displayKey => {
        const { key, name, description, note } = uniqueMetricsLookup[displayKey]
        return { key, name, description, note }
      })
    },
    searchList () {
      if (!this.getMetricSearch?.length) return this.uniqueMetricsList
      return this.uniqueMetricsList.filter((metric) => this.getFuzzyResults.has(metric.key))
    },
    showInSearch () {
      return !this.getMetricSearch?.length || this.searchList.length > 0
    },
    // Only the Custom Metrics banner follows this section, and it is hidden while searching
    showDivider () {
      return !this.getMetricSearch?.length
    },
    platformName () {
      return platformNameMap[this.getMetricsPlatform]
    }
  }
}
</script>

<style scoped>
.checkbox-input {
  border: 1px;
  box-shadow: 0px 0px 0px 1px rgba(9, 25, 72, 0.13), 0px 1px 2px 0px rgba(9, 25, 72, 0.13);
}
.inline-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  width: 24px;
  height: 24px;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 0.857px 1.714px 0 rgba(4, 26, 75, 0.13), 0 0 0 0.857px rgba(0, 56, 108, 0.08);
}
</style>